import { render, staticRenderFns } from "./GenericTemplate.vue?vue&type=template&id=d401d812"
import script from "./GenericTemplate.vue?vue&type=script&lang=js"
export * from "./GenericTemplate.vue?vue&type=script&lang=js"
import style0 from "./GenericTemplate.vue?vue&type=style&index=0&id=d401d812&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports